@if (type === 'primary' && !(spinnerId && Spinner.isShown(spinnerId))) {
    <button #button
            [attr.data-testid]="testId"
            mat-flat-button
            class="button-style primary w-100 no-wrap t-button"
            [type]="buttonType"
            [disabled]="disabled"
            [class.small-button]="size === 'small'"
            [class.t-button-small]="size === 'small'"
            [class.extra-small-button]="size === 'extra-small'"
            [class.t-button-extra-small]="size === 'extra-small'"
            [class.accent]="color === 'accent'"
            [class.orange]="color === 'orange'"
            (click)="clickListener.emit(); $event.stopPropagation();">
        <span>{{ label }}</span>
    </button>
}

@if (type === 'white' && !(spinnerId && Spinner.isShown(spinnerId))) {
    <button #button
            [attr.data-testid]="testId"
            mat-flat-button
            class="button-style white w-100 no-wrap t-button"
            [type]="buttonType"
            [disabled]="disabled"
            [class.small-button]="size === 'small'"
            [class.t-button-small]="size === 'small'"
            [class.extra-small-button]="size === 'extra-small'"
            [class.t-button-extra-small]="size === 'extra-small'"
            [class.accent]="color === 'accent'"
            [class.orange]="color === 'orange'"
            (click)="clickListener.emit(); $event.stopPropagation();">
        <span>{{ label }}</span>
    </button>
}


@if (type === 'secondary' && !(spinnerId && Spinner.isShown(spinnerId))) {
    <button #button
            [attr.data-testid]="testId"
            mat-stroked-button
            class="button-style secondary w-100 no-wrap t-button"
            [type]="buttonType"
            [class.small-button]="size === 'small'"
            [class.t-button-small]="size === 'small'"
            [class.extra-small-button]="size === 'extra-small'"
            [class.t-button-extra-small]="size === 'extra-small'"
            [class.accent]="color === 'accent'"
            [class.orange]="color === 'orange'"
            [class.icon]="iconPosition !== 'none'"
            [class.fit-content]="fitContent"
            [class.remove-padding]="removePadding"
            [disabled]="disabled"
            (click)="clickListener.emit(); $event.stopPropagation();">
        @if (iconPosition === 'none') {
            <span>{{ label }}</span>
        } @else {
            <div fxLayout="row" fxLayoutAlign="center center">
                @if (iconPosition === 'left') {
                    <ui-kit-svg class="icon mr-8"
                                [class.small-button]="size === 'small'"
                                [class.extra-small-button]="size === 'extra-small'"
                                [name]="icon"/>
                }
                <div>{{ label }}</div>
                @if (iconPosition === 'right') {
                    <ui-kit-svg class="icon ml-8"
                                [class.small-button]="size === 'small'"
                                [class.extra-small-button]="size === 'extra-small'"
                                [name]="icon"/>
                }
            </div>
        }
    </button>
}

@if (type === 'text' && !(spinnerId && Spinner.isShown(spinnerId))) {
    <button #button
            [attr.data-testid]="testId"
            mat-button
            class="button-style text w-100 no-wrap t-button"
            [type]="buttonType"
            [class.small-button]="size === 'small'"
            [class.t-button-small]="size === 'small'"
            [class.extra-small-button]="size === 'extra-small'"
            [class.t-button-extra-small]="size === 'extra-small'"
            [class.accent]="color === 'accent'"
            [class.orange]="color === 'orange'"
            [class.icon]="iconPosition !== 'none'"
            [class.fit-content]="fitContent"
            [class.remove-padding]="removePadding"
            [disabled]="disabled"
            (click)="clickListener.emit(); $event.stopPropagation();">
        <div fxLayout="row" fxLayoutAlign="center center">
            @if (iconPosition === 'left') {
                <ui-kit-svg class="icon mr-8"
                            [class.small-button]="size === 'small'"
                            [class.extra-small-button]="size === 'extra-small'"
                            [name]="icon"/>
            }
            <div>{{ label }}</div>
            @if (iconPosition === 'right') {
                <ui-kit-svg class="icon ml-8"
                            [class.small-button]="size === 'small'"
                            [class.extra-small-button]="size === 'extra-small'"
                            [name]="icon"/>
            }
        </div>
    </button>
}

@if (spinnerId && Spinner.isShown(spinnerId)) {
    <div class="spinner-container w-100 no-wrap"
         fxLayout="column" fxLayoutAlign="center center"
         [class.small-button]="size === 'small'"
         [class.extra-small-button]="size === 'extra-small'"
         [class.primary]="type === 'primary'"
         [class.secondary]="type === 'secondary'"
         [class.text]="type === 'text'">
        <ui-kit-spinner [spinnerIds]="spinnerId"
                        [diameter]="smallSizes.includes(size) ? 15 : 23"
                        [strokeWidth]="smallSizes.includes(size) ? 3 : 5"/>
    </div>
}
